import { Desdobramento } from '../types/negocio/Desdobramento';
import api from './api';
import BaseService from './BaseService';

class DesdobramentoService extends BaseService<Desdobramento> {
  constructor() {
    super('desdobramento', api);
  }

  /**
   * Lista todos os desdobramentos vinculados a um plano de ação específico.
   * @param planoAcaoGuid GUID do plano de ação
   * @param filtros Filtros opcionais (responsável, intervalo de datas, etc.)
   * @returns Promise com os desdobramentos
   */
  async listarPorPlano(
    planoAcaoGuid: string,
    filtros?: {
      responsavel?: string;
    }
  ): Promise<Desdobramento[]> {
    try {
      const params = { ...filtros };
      const response = await this.api.get(`/api/${this.route}/plano/${planoAcaoGuid}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar desdobramentos por plano:', error);
      throw error;
    }
  }

  /**
   * Atualiza a situação do kanban de um desdobramento específico.
   * @param guid GUID do desdobramento
   * @param situacaoKanban Nova situação do kanban
   * @returns Promise com o desdobramento atualizado
   */
  async atualizarSituacaoKanban(guid: string, situacaoKanban: string): Promise<Desdobramento> {
    const response = await this.api.patch(`/api/${this.route}/${guid}/situacao-kanban`, { situacaoKanban });
    return response.data;
  }

}

export const desdobramentoService = new DesdobramentoService();